import { DEFAULT_BRAND_THEME_KEY } from "../../../core/helpers/app/BrandTheme";

export default {

    state: {
        darkMode: false,
        brandTheme: DEFAULT_BRAND_THEME_KEY
    },

    mutations: {
        SET_DARK_MODE(state, value) {
            state.darkMode = Boolean(value);
        },
        SET_BRAND_THEME(state, themeKey) {
            state.brandTheme = themeKey || DEFAULT_BRAND_THEME_KEY;
        }
    }
}
